/** Header dropdown order: Heading 4 → Heading 1, then Normal text */
export const QUILL_HEADER_OPTIONS = [4, 3, 2, 1, false];

export const quillModules = {
  toolbar: [
    [{ header: QUILL_HEADER_OPTIONS }],
    ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

export const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "code-block",
  "list",
  "bullet",
  "indent",
  "align",
  "color",
  "background",
  "link",
  "image",
  "video",
];
